import { GetSearchProductsFacetsResponse } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { createStore } from 'zustand';

export interface ShopProps {
  facets: GetSearchProductsFacetsResponse;
}

export interface ShopState extends ShopProps {
  reset: () => void;
  updateFacets: (facets: GetSearchProductsFacetsResponse) => void;
}

export type ShopStore = ReturnType<typeof createShopStore>;

export const initialState: ShopProps = {
  facets: {
    categories: [],
    subcategories: [],
    countries: [],
    regions: [],
    occasions: [],
    characteristics: [],
    serviceTemperatures: [],
    prices: [],
    tags: [],
  },
};

export const createShopStore = (initProps?: Partial<ShopProps>) => {
  return createStore<ShopState>((set) => ({
    ...initialState,
    ...initProps,
    reset: () => set(initialState),
    updateFacets: (facets) => set({ facets }),
  }));
};
